import React, { useState } from 'react';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import LogoutIcon from '@mui/icons-material/Logout';
import ShieldTwoToneIcon from '@mui/icons-material/Shield';
import ListItemText from '@mui/material/ListItemText';
import {
  NavModes,
  collapsedMenuItemStyles,
  expandedMenuItemStyles,
} from '@/nav/utils/navigation.utils';
import tokens from '@/core/tokens.json';
import { ROUTE_NAMES, withRoot } from '@/core/routes/routeNames';
import AuthorizationGate from '@/authorization/AuthorizationGate/AuthorizationGate';
import { SCOPES } from '@/authorization/authorization.constants';
import useLogout from '@/hooks/useLogout';

interface SecondaryNavProps {
  type: NavModes;
}
function SecondaryNav({ type }: SecondaryNavProps) {
  const [isLogoutDisabled, setIsLogoutDisabled] = useState(false);
  const logout = useLogout();

  function onLogout() {
    if (!isLogoutDisabled) {
      void logout();
      setIsLogoutDisabled(true);
      setTimeout(() => {
        setIsLogoutDisabled(false);
      }, 10000);
    }
  }

  return (
    <>
      {type === 'expanded' ? (
        <MenuList disablePadding aria-label="Secondary Menu Links">
          <AuthorizationGate scopes={[SCOPES.VIEW_USER_AGREEMENT]}>
            <MenuItem
              onClick={() =>
                window.open(
                  withRoot(ROUTE_NAMES.USER_AGREEMENT.ROOT),
                  '_blank',
                  'noopener,noreferrer',
                )
              }
              sx={expandedMenuItemStyles()}
              title="Open user agreement in a new page"
              role="menuitem"
              tabIndex={0}
            >
              <ListItemIcon>
                {
                  <ShieldTwoToneIcon
                    fontSize="medium"
                    sx={(theme) => ({ color: theme.palette.text.primary })}
                  />
                }
              </ListItemIcon>
              <ListItemText>{tokens.MENU_ITEMS.USER_AGREEMENT}</ListItemText>
            </MenuItem>
          </AuthorizationGate>
          <MenuItem
            onClick={onLogout}
            sx={expandedMenuItemStyles()}
            title="Logout from application"
            role="menuitem"
            tabIndex={0}
          >
            <ListItemIcon>
              {
                <LogoutIcon
                  fontSize="medium"
                  sx={(theme) => ({ color: theme.palette.text.primary })}
                />
              }
            </ListItemIcon>
            <ListItemText>{tokens.MENU_ITEMS.LOGOUT}</ListItemText>
          </MenuItem>
        </MenuList>
      ) : (
        <MenuList disablePadding aria-label="Secondary Menu Links">
          <AuthorizationGate scopes={[SCOPES.VIEW_USER_AGREEMENT]}>
            <MenuItem
              onClick={() =>
                window.open(
                  withRoot(ROUTE_NAMES.USER_AGREEMENT.ROOT),
                  '_blank',
                  'noopener,noreferrer',
                )
              }
              sx={collapsedMenuItemStyles}
              role="menuitem"
              tabIndex={0}
            >
              <ShieldTwoToneIcon
                titleAccess={tokens.MENU_ITEMS.USER_AGREEMENT}
                fontSize="medium"
                sx={(theme) => ({ color: theme.palette.text.primary })}
              />
            </MenuItem>
          </AuthorizationGate>
          <MenuItem onClick={onLogout} sx={collapsedMenuItemStyles} role="menuitem" tabIndex={0}>
            <LogoutIcon
              titleAccess={tokens.MENU_ITEMS.LOGOUT}
              fontSize="medium"
              sx={(theme) => ({ color: theme.palette.text.primary })}
            />
          </MenuItem>
        </MenuList>
      )}
    </>
  );
}

export default SecondaryNav;
